import { render, staticRenderFns } from "./RubricGroupHeader.vue?vue&type=template&id=0423de0e&scoped=true&"
import script from "./RubricGroupHeader.vue?vue&type=script&lang=ts&"
export * from "./RubricGroupHeader.vue?vue&type=script&lang=ts&"
import style0 from "./RubricGroupHeader.vue?vue&type=style&index=0&id=0423de0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0423de0e",
  null
  
)

export default component.exports